module.exports = __webpack_public_path__ + "assets/img/btn-detail-bcf5d806.png";